module.exports = __webpack_public_path__ + "img/Masterclasses.99b75024.png";